import { format } from "date-fns";

export function filterConsents(allConsents, acceptedConsents) {
    const consents = [];
    allConsents.forEach((el) => {
        const children = allConsents.find((child) => child.parentId === el.id);
        const parent = allConsents.find((el2) => el2.id === el.parentId);
        const isAccepted = acceptedConsents.some(
            (acceptedConsent) => acceptedConsent.consentId === el.id && (!el.required || acceptedConsent.isAccepted)
        );

        if (children) {
            return;
        }

        if (parent) {
            const isParentAccepted = acceptedConsents.some(
                (acceptedConsent) => acceptedConsent.consentId === parent.id && (!parent.required || acceptedConsent.isAccepted)
            );

            if (!isAccepted) {
                if (!isParentAccepted) {
                    consents.push(el);
                } else {
                    el.required = false;
                    el.requiredFrom = format(new Date(parent.expiredDate), 'yyyy-MM-dd');
                    consents.push(el);
                }
            }
        } else if (!isAccepted) {
            consents.push(el);
        }
    });

    return consents;
}
